import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { StorageProvider } from '../providers/storage/storage';
import { inject, Injectable } from '@angular/core';
import { LoggerWrapper } from '../providers/logger/logger-wrapper.service';
import { LoggerFactory } from '../providers/logger/logger-factory.service';
import { REFRESH_OFFLINE_FIRST } from '../utils/http-context.util';

@Injectable({ providedIn: 'root' })
export class RefreshOfflineFirstInterceptor implements HttpInterceptor {
  private storage: StorageProvider = inject(StorageProvider);
  private logger: LoggerWrapper = inject(LoggerFactory).getInstance(this);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(REFRESH_OFFLINE_FIRST) === true) {
      this.logger.debug('Intercepting for Refresh Offline First');
      return next.handle(req).pipe(
        tap((resp) => {
          if (resp instanceof HttpResponse) {
            this.writeDataToStorage(req, resp).then();
          }
        })
      );
    }
    return next.handle(req);
  }

  async writeDataToStorage(req: HttpRequest<any>, resp: HttpResponse<any>) {
    if (resp.ok) {
      const key = this.storage.getStorageName(req.urlWithParams);
      this.logger.debug('Writing data for key:', key);
      try {
        await this.storage.set(key, resp.body, false);
      } catch (err) {
        this.logger.error(err, 'Échec de la mise en cache offline-first');
      }
    }
  }
}
